// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonCreateLabel {
  display: flex;
  font-size: 1.26rem;
  justify-content: space-between;
}

.actionSectionCreateInvoice {
  display: flex;
  margin: 0px 10px 0px 0px;
}
.actionSectionCreateInvoice .commonActionItemCreateInvoice {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 15px 0px 15px;
}
.actionSectionCreateInvoice .commonActionItemEnd {
  display: grid;
  margin-left: auto;
}

.refextSection {
  display: flex;
}

.refTextField {
  display: flex;
  flex: 0 0 100%;
  align-content: center;
}

.btnAdd {
  display: flex;
  flex: 0 0 10%;
}

.section-booking-modal {
  display: flex;
}
.section-booking-modal .left-section-booking-modal {
  display: flex;
  flex: 1 0 45%;
}
.section-booking-modal .right-section-booking-modal {
  display: flex;
  flex: 1 0 45%;
  padding-left: 5px;
}

.createinvoice-interval {
  display: flex;
}
.createinvoice-interval .left-createinvoice-interval {
  display: flex;
  flex: 1 0 45%;
}
.createinvoice-interval .right-createinvoice-interval {
  display: flex;
  flex: 1 0 45%;
  padding-left: 5px;
}

.left-section-interval {
  display: flex;
  flex: 1 0 29%;
}

.right-section-type {
  display: flex;
  flex: 1 0 55%;
  padding-left: 5px;
}

.setDisplay {
  display: flex;
}
.setDisplay .refFieldDiv, .setDisplay .bookingdateDiv {
  display: flex;
  flex: 1 0 45%;
  padding-right: 5px;
}
.setDisplay .custRefFieldDiv, .setDisplay .invoicedateDiv {
  display: flex;
  flex: 1 0 45%;
  padding-left: 5px;
}

.templateModalSections {
  display: flex;
}
.templateModalSections .template {
  display: flex;
  flex: 1 0 45%;
  padding-right: 5px;
}
.templateModalSections .date {
  display: flex;
  flex: 1 0 45%;
  padding-left: 5px;
}

.scheduleSection {
  display: flex;
  flex: 0 0 100%;
  align-content: center;
}
.scheduleSection .schedule {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1 0 45%;
}
.scheduleSection .schedule .scheduleInterval {
  display: flex;
  flex: 1 0 45%;
}
.scheduleSection .scheduleReminder {
  display: flex;
  flex: 1 0 45%;
  justify-content: flex-end;
  margin-left: 10px;
}

.typeDiv {
  display: flex;
  flex: 1 0 45%;
  padding-right: 5px;
}

.textAreaDiv {
  display: flex;
  flex: 1 0 45%;
  padding-left: 5px;
}

.actionSectionRight {
  display: flex;
  margin: 0px 10px 0px 0px;
}
.actionSectionRight .commonActionItemCreateInvoice {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 15px 0px 15px;
}

.commonactionRight {
  display: flex;
  flex: 1 0 50%;
}

.searchInvoiceDiv {
  display: flex;
  flex: 1 0 50%;
  justify-content: flex-end;
}

.setMarginLeft {
  margin-left: 25px;
}

.footerSectionArea {
  display: flex;
  justify-content: flex-end;
}

.footerFieldDiv {
  display: flex;
  flex: 0 0 60%;
}

.amountDivSection {
  display: flex;
  flex: 0 0 40%;
  justify-content: space-between;
}

.commonamountDiv {
  flex: 1 0 30%;
}

.MuiDataGrid-virtualScroller::-webkit-scrollbar {
  display: none !important;
}

.MuiDataGrid-virtualScroller {
  max-height: 870px;
  overflow-y: scroll;
  width: 100%;
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.css-pk82a1-MuiFormHelperText-root {
  font-size: 11px !important;
  margin-left: 1px !important;
}`, "",{"version":3,"sources":["webpack://./src/features/create-invoice/create-invoice.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,8BAAA;AACJ;;AAEA;EACI,aAAA;EACA,wBAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;AACR;AACI;EACI,aAAA;EAEA,iBAAA;AAAR;;AAGA;EACI,aAAA;AAAJ;;AAEA;EACI,aAAA;EACA,cAAA;EACA,qBAAA;AACJ;;AACA;EACI,aAAA;EACA,aAAA;AAEJ;;AAAA;EACI,aAAA;AAGJ;AAFI;EACI,aAAA;EACA,aAAA;AAIR;AAFI;EACI,aAAA;EACA,aAAA;EACA,iBAAA;AAIR;;AAAA;EACI,aAAA;AAGJ;AAFI;EACI,aAAA;EACA,aAAA;AAIR;AAFI;EACI,aAAA;EACA,aAAA;EACA,iBAAA;AAIR;;AADA;EACI,aAAA;EACA,aAAA;AAIJ;;AAFA;EACI,aAAA;EACA,aAAA;EACA,iBAAA;AAKJ;;AAFA;EACI,aAAA;AAKJ;AAJI;EACI,aAAA;EACA,aAAA;EACA,kBAAA;AAMR;AAJI;EACI,aAAA;EACA,aAAA;EACA,iBAAA;AAMR;;AAFA;EACI,aAAA;AAKJ;AAJI;EACI,aAAA;EACA,aAAA;EACA,kBAAA;AAMR;AAJI;EACI,aAAA;EACA,aAAA;EACA,iBAAA;AAMR;;AADA;EACI,aAAA;EACA,cAAA;EACA,qBAAA;AAIJ;AAHI;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,aAAA;AAKR;AAJQ;EACA,aAAA;EACA,aAAA;AAMR;AAHQ;EACI,aAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;AAKZ;;AADA;EACI,aAAA;EACA,aAAA;EACA,kBAAA;AAIJ;;AAFA;EACI,aAAA;EACA,aAAA;EACA,iBAAA;AAKJ;;AAHA;EACI,aAAA;EACA,wBAAA;AAMJ;AALI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;AAOR;;AAJA;EACI,aAAA;EACA,aAAA;AAOJ;;AALA;EACI,aAAA;EACA,aAAA;EACA,yBAAA;AAQJ;;AANA;EACI,iBAAA;AASJ;;AANA;EACI,aAAA;EACA,yBAAA;AASJ;;AAPA;EACI,aAAA;EACA,aAAA;AAUJ;;AARA;EACI,aAAA;EACA,aAAA;EACA,8BAAA;AAWJ;;AARA;EACI,aAAA;AAWJ;;AARA;EACI,wBAAA;AAWJ;;AATE;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,gCAAA;EACA,mCAAA;AAYJ;;AAVG;EACC,0BAAA;EACA,2BAAA;AAaJ","sourcesContent":[".commonCreateLabel {\n    display: flex;\n    font-size: 1.26rem;\n    justify-content: space-between;\n}\n\n.actionSectionCreateInvoice{\n    display: flex;\n    margin: 0px 10px 0px 0px;\n    // justify-content: space-between;\n    .commonActionItemCreateInvoice{\n        display: flex;    \n        flex-direction: column;\n        align-items: center;\n        padding: 0px 15px 0px 15px;\n    }\n    .commonActionItemEnd{\n        display: grid;\n        // padding: 0px 15px 0px 15px;\n        margin-left: auto;\n    }\n}\n.refextSection{\n    display: flex;\n}\n.refTextField{\n    display: flex;\n    flex: 0 0 100%;  \n    align-content: center; \n}\n.btnAdd{\n    display: flex;\n    flex: 0 0 10%;\n}\n.section-booking-modal{\n    display: flex;\n    .left-section-booking-modal{\n        display: flex;\n        flex:1 0 45%;\n    }\n    .right-section-booking-modal{\n        display: flex;\n        flex:1 0 45%;\n        padding-left: 5px;\n    }\n}\n\n.createinvoice-interval{\n    display: flex;\n    .left-createinvoice-interval{\n        display: flex;\n        flex:1 0 45%;\n    }\n    .right-createinvoice-interval{\n        display: flex;\n        flex:1 0 45%;\n        padding-left: 5px;\n    }\n}\n.left-section-interval{\n    display: flex;\n    flex:1 0 29%;\n}\n.right-section-type{\n    display: flex;\n    flex:1 0 55%;\n    padding-left: 5px;\n}\n\n.setDisplay{\n    display: flex;\n    .refFieldDiv,.bookingdateDiv{\n        display: flex;\n        flex: 1 0 45%;\n        padding-right: 5px;\n    }\n    .custRefFieldDiv,.invoicedateDiv{\n        display: flex;\n        flex: 1 0 45%;\n        padding-left: 5px;\n        // margin-top: 10px;\n    }\n}\n.templateModalSections{\n    display: flex;\n    .template{\n        display: flex;\n        flex: 1 0 45%;\n        padding-right: 5px;\n    }\n    .date{\n        display: flex;\n        flex: 1 0 45%;\n        padding-left: 5px;\n        // margin-top: 10px;\n    }\n}\n\n.scheduleSection{\n    display: flex;\n    flex: 0 0 100%;\n    align-content: center;  \n    .schedule{\n        display: flex;\n        align-items: center;\n        justify-content:flex-start;\n        flex: 1 0 45%;\n        .scheduleInterval{\n        display: flex;\n        flex: 1 0 45%;\n        }\n    }\n        .scheduleReminder{\n            display: flex;\n            flex: 1 0 45%;  \n            justify-content: flex-end;\n            margin-left: 10px;\n    }\n}\n\n.typeDiv{\n    display: flex;\n    flex: 1 0 45%;\n    padding-right: 5px;\n}\n.textAreaDiv{\n    display: flex;\n    flex: 1 0 45%;\n    padding-left: 5px;\n}\n.actionSectionRight{\n    display: flex;\n    margin: 0px 10px 0px 0px; \n    .commonActionItemCreateInvoice{\n        display: flex;    \n        flex-direction: column;\n        align-items: center;\n        padding: 0px 15px 0px 15px;\n    }\n}\n.commonactionRight{\n    display: flex;\n    flex: 1 0 50%;\n}\n.searchInvoiceDiv{\n    display: flex;\n    flex: 1 0 50%;\n    justify-content: flex-end;\n}\n.setMarginLeft{\n    margin-left: 25px;\n}\n\n.footerSectionArea{\n    display: flex;\n    justify-content: flex-end;\n}\n.footerFieldDiv{\n    display: flex;\n    flex: 0 0 60%;\n}\n.amountDivSection{\n    display:flex;\n    flex: 0 0 40%;\n    justify-content: space-between;\n}\n\n.commonamountDiv{\n    flex: 1 0 30%;\n}\n\n.MuiDataGrid-virtualScroller::-webkit-scrollbar {\n    display: none !important;\n  }\n  .MuiDataGrid-virtualScroller {\n    max-height: 870px;\n    overflow-y: scroll;\n    width: 100%;\n    scrollbar-width: none !important;\n    -ms-overflow-style: none !important;\n  }\n   .css-pk82a1-MuiFormHelperText-root{\n    font-size: 11px !important;\n    margin-left: 1px !important;\n  }\n\n//   .leftSectionCreateInvoice{\n//     height: 580px;\n//   }\n// .scroll-hide {\n//     overflow: hidden;\n//   }\n// .scroll-hide::-webkit-scrollbar {\n//     display: none;\n//   }\n// .textBoxReq::after{\n//     content: '*';\n//     font-weight: bold;\n// }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
